var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    stroke: "#545454",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.058 7.11a1.333 1.333 0 0 0 .943 2.277h.113a1.1 1.1 0 0 1 1.007.667 1.1 1.1 0 0 1-.22 1.213l-.04.04a1.334 1.334 0 1 0 1.886 1.887l.04-.04a1.1 1.1 0 0 1 1.214-.22 1.1 1.1 0 0 1 .72 1.006V14a1.333 1.333 0 1 0 2.666 0v-.113a1.1 1.1 0 0 1 .667-1.007 1.1 1.1 0 0 1 1.213.22l.04.04a1.333 1.333 0 1 0 1.887-1.886l-.04-.04a1.102 1.102 0 0 1-.22-1.214 1.101 1.101 0 0 1 1.007-.666H14a1.333 1.333 0 0 0 .943-2.276M4.668 6 8 9.335m0 0 3.333-3.333M8.001 9.334v-8",
    stroke: "{stroke}",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingDown);
export default __webpack_public_path__ + "static/media/SettingDown.77cd8c2536ae20419cfa9782bdc29f91.svg";
export { ForwardRef as ReactComponent };